import { Search, Filter } from 'lucide-react'

interface OpportunitiesSearchProps {
  searchTerm: string
  onSearchChange: (value: string) => void
  showFilters: boolean
  onToggleFilters: () => void
  placeholder?: string
}

export default function OpportunitiesSearch({ 
  searchTerm, 
  onSearchChange, 
  showFilters, 
  onToggleFilters,
  placeholder = "Search opportunities by name, company, pain point, or solution..."
}: OpportunitiesSearchProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-slate-200 dark:border-slate-700 rounded-md focus:ring-2 focus:ring-accent focus:border-accent bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500"
        />
      </div>
      <button
        onClick={onToggleFilters}
        className="flex items-center space-x-2 px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300"
      >
        <Filter className="w-4 h-4" />
        <span>Filters</span>
      </button>
    </div>
  )
}